import React, { useState, useEffect, useCallback } from "react";
import ListSearch from "../../components/custom/searches/ListSearch";
import Maper from "../../components/common/Maper";
import { mkSchool } from "../../assets/images";
import { USER_DATA } from "../../helpers/constants";
import Select from "react-select";
import { getSchools } from "../../services/schoolService";
import { getFormations } from "../../services/formationService";
import { gethomeFilter, getFilterresult } from "../../services/homeService";
import Filter from "../../components/common/Filter";
import premium from "../../assets/fonts/premium.svg";
import AdvertisementImage from "../../assets/images/Advertisement.svg";
import { useHistory } from "react-router-dom";

// import data
import {
  COUNTRIES,
  DIPLOMES,
  FORMATIONS_DURATIONS,
  LANGUES,
  SECTORS,
} from "../../helpers/dummies";
import Flag from "react-flagkit";

const Searches = ({ partenary }) => {
  const [validRun, setvalidRun] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
  });
  const [loading, setLoading] = useState(false);
  // console.log(partenary);
  const history = useHistory();
  // console.log(history.location.state,' history');
  const [userName, setUserName] = useState("");
  const [isLogin, setIsLogin] = useState("");
  const [dataCount, setDataCount] = useState(0);
  const [zIndex, setZIndex] = useState("");
  const [options, setOptions] = useState([]);
  const [levels, setlevels] = useState([]);
  const [filterCountries, setFilterCountries] = useState([]);
  const [filterLanguages, setFilterLanguages] = useState([]);
  const [filterSections, setFilterSections] = useState([]);
  const [filterTrainingDuration, setFilterTrainingDuration] = useState([]);
  const [selectedFiltersData, setSelectedFiltersData] = useState({
    language: "",
    countryId: "",
    formationLevel: "",
    section: null,
    trainingDuration: "",
    limit: 10,
    page: 0
  });

  const customStyles = {
    control: (provided) => ({
      ...provided,
      border: "none",
      boxShadow: "none",
    }),
  };

  //the core data from the api without any filter apply on
  const [searchListData, setSearchListData] = useState([]);

  //store data for select input
  const [countryData, setCountryOptions] = useState("");
  const [selectDiplomes, setSelectDiplomes] = useState("");
  const [selectSectors, setSelectSectors] = useState("");
  const [selectCountries, setSelectCountries] = useState("");
  const [selectLangues, setSelectLangues] = useState("");
  const [selectTrainingDuration, setSelectTrainingDuration] = useState("");
  const [selectFormationsDurations, setSelectFormationsDurations] =
    useState("");
  const [selectOrdination, setSelectOrdination] = useState("");

  //result after filter the data with the selects
  const [filteredResults, setFilteredResults] = useState([]);
  const [resultsCount, setResultsCount] = useState(0);

  const [lang, setlang] = useState([]);
  const totalPage = Math.ceil(resultsCount / pagination.limit);

  //handle select onChange for each select
  const handleDiplomesChange = (selectedOption) => {
    setSelectDiplomes(selectedOption);
  };
  const handleSectorsChange = (selectedOption) => {
    setSelectSectors(selectedOption);
  };
  const handleCountriesChange = (selectedOption) => {
    setSelectCountries(selectedOption);
  };
  const handleLanguesChange = (selectedOption) => {
    setSelectLangues(selectedOption);
  };
  const handleFormationsDurationsChange = (selectedOption) => {
    setSelectFormationsDurations(selectedOption);
  };

  const handleTrainingDurationChange = (selectedOption) => {
    setSelectTrainingDuration(selectedOption);
  };

  const handleOrdinationChange = (selectedOption) => {
    setSelectOrdination(selectedOption);
  };

  //function for fetching data in api
  const getSchoolsData = async () => {
    try {
      let obj = {
        language: selectedFiltersData ? selectedFiltersData.language : "",
        countryId: selectedFiltersData ? selectedFiltersData.countryId : "",
        formationLevel: selectedFiltersData ? selectedFiltersData.formationLevel : "",
        section: selectedFiltersData ? selectedFiltersData.section : "",
        trainingDuration: selectedFiltersData ? selectedFiltersData.trainingDuration : "",
        limit: 10,
        page: 0
      }
      // const response = await getFormations(pagination?.page, pagination?.limit);
      const response = await getFilterresult(obj)
      const { data } = response;
      setSearchListData(data);
      //  setPagination((prev) => ({ ...prev, page: pagination.page + 1  }));
      //  setSelectedFiltersData((prev) => ({ ...prev, page: selectedFiltersData.page + 1  }));
      setFilteredResults(data);
      setResultsCount(response?.total);
      //  setSelectedFiltersData((prev) => ({ ...prev, page: selectedFiltersData.page + 1  }));
    } catch (error) {
      console.error(error);
    }
  };

  //call the function when the component is rendering
  useEffect(() => {
    getSchoolsData();
  }, []);

  useEffect(() => {
    try {
      const userData = JSON.parse(localStorage.getItem(USER_DATA));
      const userPseudo = userData.name?.split(" ");
      const userName = userPseudo[1];

      setIsLogin(userData ? true : false);

      setUserName(userName);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const applyFilters = useCallback(() => {
    console.log({ searchListData });
    let filteredData = searchListData;

    // if (selectCountries) {
    //   console.log("selectCountries", selectCountries);
    //   const selectedCountry = selectCountries.label.toLowerCase();
    //   filteredData = filteredData.filter((school) =>
    //     school.school.country.name.toLowerCase().includes(selectedCountry)
    //   );
    // }
    if (selectCountries) {
      const selectedCountry = selectCountries.label.toLowerCase();
      filteredData = filteredData.filter((item) => {
        // Check if the item has a school property and a country property
        if (item.school && item.school.country && item.school.country.name) {
          // Convert the country name to lowercase and check if it includes the selected country
          return item.school.country.name
            .toLowerCase()
            .includes(selectedCountry);
        }

        // If the structure doesn't match, consider it as not matching the selected country
        return false;
      });
    }

    if (selectDiplomes) {
      const selectedFormationLevel = selectDiplomes.label.toLowerCase();
      console.log("selectedFormationLevel", selectedFormationLevel);
      filteredData = filteredData.filter((school) =>
        school.formationLevel.toLowerCase().includes(selectedFormationLevel)
      );
      // filteredData = filteredData.filter((school) =>
      //   school.formations.some((formation) =>
      //     formation.formationLevel
      //       .toLowerCase()
      //       .includes(selectedFormationLevel)
      //   )
      // );
    }

    // Function to check if selected language matches any word in formationLanguage
    const languageMatches = (formationLanguage, selectedLanguage) => {
      if (!formationLanguage || !selectedLanguage) {
        return false;
      }

      // Split formationLanguage into individual words
      const formationWords = formationLanguage.split(/\s+/);

      // Split selectedLanguage into individual words
      const selectedWords = selectedLanguage.split(/\s+/);

      // Check if each selected word is present in formationLanguage
      const isMatch = selectedWords.every((selectedWord) =>
        formationWords.some(
          (formationWord) =>
            formationWord.toLowerCase() === selectedWord.toLowerCase()
        )
      );

      return isMatch;
    };

    if (selectLangues) {
      const selectedLanguage = selectLangues.label.toLowerCase().trim();
      filteredData = selectedLanguage;
      // filteredData = filteredData.filter((school) =>
      //   school.formations.some((formation) => {
      //     const formationLanguage = formation.language?.toLowerCase().trim();
      //     return languageMatches(formationLanguage, selectedLanguage);
      //   })
      // );
      filteredData = filteredData.filter((school) =>
        school.formations.some((formation) => {
          const formationLanguage = formation.language?.toLowerCase().trim();
          return languageMatches(formationLanguage, selectedLanguage);
        })
      );
    }

    if (selectFormationsDurations) {
      const selectedDuration = selectFormationsDurations.label;
      filteredData = filteredData.filter((school) =>
        school.formations.some(
          (formation) => formation.trainingDuration === selectedDuration
        )
      );
    }
    if (selectTrainingDuration) {
      console.log("==========", { selectTrainingDuration });
      const selectedDuration = selectTrainingDuration.name;
      filteredData = filteredData.filter((school) =>
        school.name.toLowerCase().includes(selectedDuration)
      );
    }

    if (selectOrdination) {
      const sortOrder = selectOrdination.value === "asc" ? 1 : -1;
      filteredData.sort((a, b) =>
        a.note > b.note ? sortOrder : b.note > a.note ? -sortOrder : 0
      );
    }

    if (selectOrdination && selectOrdination.value === "desc") {
      filteredData.sort((a, b) => a.name.localeCompare(b.name));
    } else {
      filteredData.sort((a, b) => b.name.localeCompare(a.name));
    }

    setFilteredResults(filteredData);
  }, [
    searchListData,
    selectDiplomes,
    selectSectors,
    selectCountries,
    selectLangues,
    selectTrainingDuration,
    selectFormationsDurations,
    selectOrdination,
  ]);

  useEffect(() => {
    gethomeFilter()
      .then((res) => {
        const {
          country,
          language,
          formationLevel,
          section,
          trainingDurations,
        } = res;
        if (country?.length > 0) {
          const transformedCountries = country.map((ele) => ({
            value: ele.id,
            label: ele.continent,
          }));
          setFilterCountries(transformedCountries);
        }
        if (formationLevel?.length > 0) {
          const transformedLevels = formationLevel.map((ele) => ({
            value: ele.id,
            label: ele.name,
          }));
          setlevels(transformedLevels);
        }
        if (language?.length > 0) {
          const transformedLanguages = language.map((ele) => ({
            value: ele.id,
            label: ele.name,
          }));
          setFilterLanguages(transformedLanguages);
        }
        if (section?.length > 0) {
          const transformedSections = section.map((ele) => ({
            value: ele.id,
            label: ele.name,
          }));
          setFilterSections(transformedSections);
        }
        if (trainingDurations?.length > 0) {
          const transformedTrainingDurations = trainingDurations?.map(
            (ele) => ({
              value: ele.id,
              label: ele.name,
            })
          );
          setFilterTrainingDuration(transformedTrainingDurations);
        }
      })
      .catch((err) => {
        console.error(err); // Log the error to the console
      });
  }, []); // The empty dependency array indicates

  useEffect(() => {
    applyFilters();
  }, [applyFilters]);

  useEffect(() => {
    try {
      const userData = JSON.parse(localStorage.getItem(USER_DATA));
      // const userPseudo = userData.name?.split(" ");
      // const userName = userPseudo[1];
      const userName = userData.name;

      setIsLogin(userData ? true : false);

      setUserName(userName);
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    // Call your API with the current filter values
    // Replace 'yourApiEndpoint' with the actual API endpoint

    if (
      selectedFiltersData.language ||
      selectedFiltersData.countryId ||
      selectedFiltersData.formationLevel ||
      selectedFiltersData.trainingDuration ||
      selectedFiltersData.section
    ) {
      let obj = {
        language: selectedFiltersData ? selectedFiltersData.language : "",
        countryId: selectedFiltersData ? selectedFiltersData.countryId : "",
        formationLevel: selectedFiltersData ? selectedFiltersData.formationLevel : "",
        section: selectedFiltersData ? selectedFiltersData.section : "",
        trainingDuration: selectedFiltersData ? selectedFiltersData.trainingDuration : "",
        limit: 10,
        page: 0
      }
      getFilterresult(obj)
        .then((res) => {
          if (res.data.length > 0) {
            setFilteredResults(res.data);
            setPagination((prev) => ({
              ...prev,
              page: 1
            }))
            // setSelectedFiltersData((prev) => ({ ...prev, page: selectedFiltersData?.page   }))
          } else {
            setFilteredResults([]);
          }
        })
        .catch((error) => console.error("Error fetching data:", error));
    }
    //else {
    //   let page=0;
    //   let limit=10
    //   getFormations(pagination?.page,pagination?.limit)
    //     .then((res) => {
    //       const { data } = res;
    //       setFilteredResults(data);
    //     })
    //     .catch((err) => {
    //       console.error("Error fetching data:", err);
    //     });
    // }
  }, [
    // selectedFiltersData,
    selectedFiltersData.section,
    selectedFiltersData.language,
    selectedFiltersData.countryId,
    selectedFiltersData.formationLevel,
    selectedFiltersData.trainingDuration
  ]);

  // ******* Reset all select input ************** //

  const resetFilter = () => {
    setSelectDiplomes("");
    // setSelectSectors("");
    setSelectCountries("");
    setSelectLangues("");
    setSelectFormationsDurations("");
    setSelectOrdination("");

    setSelectedFiltersData({
      page: 0,
      limit: 10,
      language: "",
      countryId: "",
      formationLevel: "",
      section: null,
      trainingDuration: "",
    });
    getFilterresult({
      language: "",
      countryId: "",
      formationLevel: "",
      section: 0,
      trainingDuration: "",
      limit: 10,
      page: 0
    }).then((res) => {
      if (res.data.length > 0) {
        setFilteredResults(res.data)
      }
    }).catch((err) => console.error(err))

    // setSelectSectors(filteredResults[0]);
  };

  //set dataCount when not and when filtering data from API
  useEffect(() => {
    if (filteredResults && filteredResults.length) {
      setDataCount(filteredResults.length);
    } else {
      setDataCount(searchListData.length);
    }
  }, [filteredResults, searchListData.length]);

  // When clicked outside the Maper set z-index to -1 otherwise z-index should === 1;
  const handleClickOutside = (e) => {
    if (e.target.id === "searches-map") {
      setZIndex("-1");
    } else {
      setZIndex("1");
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  // console.log(filteredResults ? filteredResults :[])

  // *********handle on scroll *********//

  const handleScroll = async () => {
    try {
      // if (
      //   window.innerHeight + document.documentElement.scrollTop ===
      //   document.documentElement.offsetHeight
      // ) {
      if (totalPage > pagination?.page + 1) {
        setLoading(true);
        let obj = {
          language: selectedFiltersData ? selectedFiltersData.language : "",
          countryId: selectedFiltersData ? selectedFiltersData.countryId : "",
          formationLevel: selectedFiltersData ? selectedFiltersData.formationLevel : "",
          section: selectedFiltersData ? selectedFiltersData.section : "",
          trainingDuration: selectedFiltersData ? selectedFiltersData.trainingDuration : "",
          limit: 10,
          page: pagination?.page
        }

        await getFilterresult(obj)
          .then((res) => {
            console.log("response", { res });
            let pageNum = res.total - pagination?.limit * pagination?.page
            if (pageNum > 0) {
              setPagination((prev) => ({
                ...prev,
                page: pagination?.page + 1
              }))
              if (res.data.length > 0) {
                // setFilteredResults((prev) => [...prev, ...res.data]);
                setFilteredResults((prev) => [...prev, ...res.data]);
                //  setSelectedFiltersData((prev) => ({ ...prev, page: selectedFiltersData.page + 1  }))
                // setPagination({
                //   page: pagination.page + 1,
                //   limit: 10,
                // });
                setTimeout(() => {
                  setLoading(false);
                  console.log("false")
                }, 500);
              } else {
                console.log("false");
                setLoading(false);
                setPagination((prev) => ({ ...prev, page: 0 }))
                // setSelectedFiltersData((prev) => ({ ...prev, page: selectedFiltersData.page - selectedFiltersData.page }))
              }
            } else {
              console.log("false");
              setLoading(false)
              setPagination((prev) => ({ ...prev, page: 0 }))
              // setSelectedFiltersData((prev) => ({ ...prev, page: selectedFiltersData.page - selectedFiltersData.page }))
            }
          })
          .catch((err) => {
            console.error(err);
            setLoading(false);
            setPagination((prev) => ({ ...prev, page: 0 }))
            // setSelectedFiltersData((prev) => ({ ...prev, page: selectedFiltersData.page - selectedFiltersData.page }))
          });
      }
    } catch (err) {
      console.error(err);
    }
  };

  // useEffect(() => {
  //   window.addEventListener("scroll", handleScroll);
  //   return () => {
  //     window.removeEventListener("scroll", handleScroll);
  //   };
  // }, [
  //   handleScroll,
  //   // selectedFiltersData.language ,
  //   // selectedFiltersData.countryId ,
  //   // selectedFiltersData.formationLevel ,
  //   // selectedFiltersData.trainingDuration
  // ]);

  return (
    <React.Fragment>
      <div id="searches-layout">
        <div className="container searches-content pt-16">
          <div className="flex justify-between items-center text-ace-ace_title mt-4">
            <p className="lg:text-lg font-normal">Filtrez vos résultats</p>
            <button
              type="button"
              className="rounded-md  bg-opacity-5 px-2 md:px-4 py-2"
              onClick={resetFilter}
            >
              Effacer tous les filtres
            </button>
          </div>

          <div className="w-full py-3 z-30">
            <Filter withShadow>
              <div className="d-flex">
                <Select
                  placeholder="Niveau d'étude"
                  className="w-100 b-none"
                  options={levels}
                  value={
                    selectedFiltersData.formationLevel
                      ? { label: selectedFiltersData.formationLevel }
                      : null
                  }
                  onChange={(selectedOption) =>
                    setSelectedFiltersData({
                      ...selectedFiltersData,
                      formationLevel: selectedOption?.label || "", // Use optional chaining to avoid issues if selectedOption is undefined
                    })
                  }
                  isClearable
                  styles={customStyles}
                />
                <Select
                  placeholder="Filière"
                  className="w-100 b-none"
                  options={filterSections}
                  value={
                    selectedFiltersData.section !== null &&
                      selectedFiltersData.section !== undefined
                      ? filterSections.find(
                        (option) =>
                          option.value === selectedFiltersData.section
                      )
                      : null
                  }
                  onChange={(selectedOption) =>
                    setSelectedFiltersData({
                      ...selectedFiltersData,
                      section: selectedOption?.value || null,
                    })
                  }
                  isClearable
                  styles={customStyles}
                />

                <Select
                  placeholder="Ville ou  pays"
                  className="w-100 b-none"
                  options={filterCountries}
                  value={
                    selectedFiltersData.countryId
                      ? { label: selectedFiltersData.countryId }
                      : null
                  }
                  onChange={(selectedOption) =>
                    setSelectedFiltersData({
                      ...selectedFiltersData,
                      countryId: selectedOption?.label || "", // Use optional chaining to avoid issues if selectedOption is undefined
                    })
                  }
                  isClearable
                  styles={customStyles}
                />
                <Select
                  placeholder="Langues"
                  className="w-100 b-none"
                  options={filterLanguages}
                  value={
                    selectedFiltersData.language
                      ? { label: selectedFiltersData.language }
                      : null
                  }
                  onChange={(selectedOption) =>
                    setSelectedFiltersData({
                      ...selectedFiltersData,
                      language: selectedOption?.label || "", // Use optional chaining to avoid issues if selectedOption is undefined
                    })
                  }
                  isClearable
                  styles={customStyles}
                />
                <Select
                  placeholder="Durée de la formation"
                  className="w-100 b-none"
                  options={filterTrainingDuration}
                  value={
                    selectedFiltersData.trainingDuration
                      ? {
                        value: 0,
                        label: selectedFiltersData.trainingDuration,
                      }
                      : null
                  }
                  onChange={(selectedOption) => {
                    setSelectedFiltersData({
                      ...selectedFiltersData,
                      trainingDuration: selectedOption?.label,
                    });
                  }}
                  isClearable
                  styles={customStyles}
                />
              </div>
            </Filter>
          </div>
          <div>
            <div className="flex flex-col-reverse md:flex-row md:justify-between items-start md:items-center mb-3 text-ace-dark_gray">
              {isLogin ? (
                <p className="text-xs md:text-lg">
                  {`${userName ? userName : ""}, nous avons trouvé`}{" "}
                  <span className="font-semibold">
                    {selectedFiltersData.length} formations
                  </span>{" "}
                  pour vous!
                </p>
              ) : (
                <p>Veuillez vous connecter pour voir les formations.</p>
              )}
              {/* <div className="w-full z-20 md:w-auto flex justify-between items-center space-x-2 pb-3 md:pb-0 text-md md:text-lg">
                <span className="ordination w-1/2 text-center md:w-auto px-8 md:px-0 py-2.5 bg-white md:py-0 shadow-md md:shadow-none rounded-md md:rounded-none md:flex justify-center items-center">
                  Ordination<span className="hidden md:flex">:</span>
                </span>{" "}
                <Select
                  placeholder="Ordination"
                  className="w-48"
                  options={[
                    { value: "asc", label: "Croissant" },
                    { value: "desc", label: "Décroissant" },
                  ]}
                  value={selectOrdination}
                  onChange={handleOrdinationChange}
                  isClearable
                  styles={customStyles}
                />
              </div> */}
            </div>
          </div>
          <div className="flex flex-col md:flex-row space-y-3 md:space-y-0 md:space-x-6">
            <div className="searches-map">
              <Maper
                withPopup
                icon={mkSchool}
                items={filteredResults ? filteredResults : filteredResults}
                redirectLink="/schools"
                zIndex={zIndex}
                key={mkSchool}
                className="mapper"
              />
            </div>
            <div className="searches-list">
              {filteredResults.length > 0 ? (
                <>{
                  filteredResults?.map((data, index) => {
                    const { school } = data;
                    const isPrivateSchool = !partenary && school?.partenary === 0;
                    const showOverlay = school?.isPublic !== 1;

                    return (
                      <React.Fragment key={data.id}>
                        {isPrivateSchool && showOverlay ? (
                          <div className="relative w-full mb-4">
                            <ListSearch
                              name={school ? school.name : ""}
                              city={data.city}
                              // publicId={data.publicId}
                              publicId={school ? school.publicId : ""}
                              trainingDuration={data ? data.trainingDuration : ""}
                              language={data ? data.language : ""}
                              teachingMode={data ? data.teachingMode : ""}
                              note={data.note ? data.note : ""}
                              formationName={data ? data.name : ""}
                              annualBackToSchool={data?.annualBackToSchool}
                            // loading= {loading}
                            />
                            <div className='w-full absolute top-0 left-0 z-10 flex items-center space-x-3 p-3'>
                              <Flag
                                className="ms-1 border border-dark"
                                height={16}
                                width={22}
                              />
                              <p className='text-[#505050] text-lg font-semibold'>{school?.country_name || "Togo"}</p>
                            </div>
                            <div className="w-full absolute flex flex-1 justify-center items-center top-0 left-0 h-full flex-col backdrop-filter backdrop-blur-md bg-opacity-30 rounded-lg">
                              <div className='w-full flex space-x-2 justify-center items-center'>
                                <img src={premium} alt="premium" className="w-8" />
                                <p className="text-[#005073] text-lg font-semibold">Accessible aux abonnés</p>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <>
                            <ListSearch
                              name={school ? school.name : ""}
                              city={data.city}
                              // publicId={data.publicId}
                              publicId={school ? school.publicId : ""}
                              trainingDuration={data ? data.trainingDuration : ""}
                              language={data ? data.language : ""}
                              teachingMode={data ? data.teachingMode : ""}
                              note={data.note ? data.note : ""}
                              formationName={data ? data.name : ""}
                              annualBackToSchool={data?.annualBackToSchool}
                            // loading= {loading}
                            />
                          </>
                        )}
                        {(index + 1) % 10 === 0 &&
                          (<div className="relative  mb-4 ">
                            <img className="rounded-xl w-full" src={AdvertisementImage} alt="Image" />
                          </div>)}
                      </React.Fragment>
                    );
                  })}
                  {loading && <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div className="spinner-border" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>}
                  {totalPage > pagination?.page + 1 && (
                    <div className="load-more-btn-box text-center mt-3">
                      <button type="button" className="btn" onClick={handleScroll}>Charger plus</button>
                    </div>
                  )}
                </>
              ) : (
                <div className="ace_formation_card rounded-xl bg-white relative">
                  <div className="flex justify-between items-center px-3 pt-3">
                    <div className="w-4/5">
                      <h3 className="font-medium text-lg text-ace-dark_green">
                        <div className="flex items-center space-x-2">
                          There is no formation available
                        </div>
                      </h3>
                    </div>
                  </div>
                </div>
              )}

            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Searches;
